import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import TransactionsHistory from '../components/TransactionsHistory';
import { Header } from '../components/Header';
import { ArrowLeft } from 'lucide-react';
import { Session } from '@supabase/supabase-js';
import { supabase } from '../lib/supabase';

interface TransactionsPageProps {
  session?: Session | null;
}

const TransactionsPage: React.FC<TransactionsPageProps> = ({ session: propSession }) => {
  const [session, setSession] = React.useState<Session | null>(propSession || null);
  const [loading, setLoading] = React.useState(!propSession);
  const navigate = useNavigate();
  
  // Si no se proporcionó la sesión como prop, intentamos obtenerla
  useEffect(() => {
    if (!propSession) {
      const getSession = async () => {
        setLoading(true);
        const { data } = await supabase.auth.getSession();
        setSession(data.session);
        setLoading(false);
      };
      
      getSession();
    }
  }, [propSession]);
  
  // Redirigir si no hay sesión después de cargar
  useEffect(() => {
    if (!loading && !session) {
      navigate('/');
    }
  }, [session, loading, navigate]);
  
  if (loading) {
    return (
      <div className="min-h-screen bg-gray-900 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }
  
  return (
    <div className="min-h-screen bg-gray-900">
      <Header 
        session={session} 
        onAuthClick={() => navigate('/')}
      />
      
      <div className="max-w-7xl mx-auto px-4 py-8">
        <button 
          onClick={() => navigate('/dashboard')}
          className="flex items-center gap-2 text-blue-400 hover:text-blue-300 mb-6 transition-colors"
        >
          <ArrowLeft className="w-5 h-5" />
          <span>Volver al Dashboard</span>
        </button>
        
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-white">Historial de transacciones</h1>
          <p className="text-gray-400 mt-2">
            Consulta el historial completo de tus transacciones, compras y usos de monedas
          </p>
        </div>
        
        {session?.user && (
          <TransactionsHistory 
            user={session.user} 
            fullPage={true}
            className="mb-8"
          />
        )}
      </div>
    </div>
  );
};

export default TransactionsPage; 